<template>
  <Layout>
    <q-card class="flexbox" style="position: relative">
      <div class="profile-header">
        <div class="profile-header-title">Locations of {{ companyName }} company</div>
        <div class="profile-header-icons">
          <q-btn color="red" :size="$q.screen.gt.sm ? 'md' : 'sm' " round @click="$store.commit('location/SET_ADD',true)">
            <q-icon color="white" name="fas fa-plus" size="15px" class="cursor-pointer"></q-icon>
          </q-btn>
        </div>
      </div>
      <div class="profile-content">
        <div style="width: 100%">
          <loading v-if="locations.length == 0 && loading"></loading>
          <empty-value
            description="If you want to add location please hit the button."
            name="location"
            v-if="locations.length == 0 && !loading"
          ></empty-value>
          <div v-else class="location-container">
            <location
              v-for="(item, index) in locations"
              :index="index"
              :location="item"
              :key="item.id"
            ></location>
          </div>
        </div>
      </div>
      <location-confirm></location-confirm>
      <location-add-dialog></location-add-dialog>
      <location-edit></location-edit>
    </q-card>
  </Layout>
</template>

<script>
import axios from "../axios/index";
import Layout from "../components/Layout";
import Confirm from "../components/Confirm";
import Loading from "../components/Loading";
import EmptyValue from "../components/EmptyValue";
import Location from "../components/Location";
import LocationAddDialog from "../components/LocationAddDialog";
import LocationEdit from "../components/LocationEdit";
import LocationConfirm from "../components/LocationConfirm";
export default {
  data() {
    return {
      companyName: null,
    };
  },
  components: {
    LocationEdit,
    LocationConfirm,
    LocationAddDialog,
    Loading,
    EmptyValue,
    Confirm,
    Layout,
    Location: () => import("../components/Location"),
  },
  async mounted() {
    this.locations = [];
    await this.getLocations(this.$route.params.id);
    await this.findCompany(this.$route.params.id);
  },
  methods: {
    async findCompany(id) {
      const { data } = await axios.get(`company/${id}`);
      this.selectedCompany = data.data;
      this.companyName = data.data.name;
    },
    async getLocations(companyId) {
      try {
        this.loading = true;
        const params = {
          company_id: companyId,
        };
        const { data } = await axios.get("locations", { params });
        this.locations = data.data;
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    companies: {
      get() {
        return this.$store.state.company.companies;
      },
      set(val) {
        this.$store.commit("company/SET_USER_COMPANIES", val);
      },
    },
    selectedCompany: {
      get() {
        return this.$store.state.location.selectedCompany;
      },
      set(val) {
        this.$store.commit("location/SET_SELECTED_COMPANY", val);
      },
    },
    locations: {
      get() {
        return this.$store.state.location.locations;
      },
      set(val) {
        this.$store.commit("location/SET_LOCATIONS", val);
      },
    },
    loading: {
      get() {
        return this.$store.state.location.loading;
      },
      set(val) {
        this.$store.commit("location/SET_LOADING", val);
      },
    },
  },
  metaInfo() {
    return {
      title: "Managing the owned Locations | FMS",
      // title: "FMS - Build your network in your field of interest",
      meta: [
        {
          name: "description",
          // "FMS is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.",
          content: "",
        },
        {
          property: "og:title",
          content: "Managing the owned Locations | FMS",
        },
        { property: "og:site_name", content: "FMS" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  }
};
</script>
